<template>
  <div class="mobile-layout">
    <div class="mobile-header">
      <div class="logo">
        <img :src="contact.web_site_logo" alt="logo">
        <span>{{ contact.web_site_logo_text }}</span>
      </div>
      <div class="menu-icon" @click="toggleMenu">
        <i class="el-icon-menu"></i>
      </div>
    </div>

    <!-- 移动端菜单 -->
    <div class="mobile-menu" :class="{ 'menu-active': isMenuOpen }">
      <div class="menu-header">
        <span>菜单导航</span>
        <i class="el-icon-close" @click="toggleMenu"></i>
      </div>
      <div class="menu-list">
        <div
          v-for="item in topNav"
          :key="item.id"
          class="menu-item"
          @click="handleMenuClick(item)"
        >
          {{ item.name }}
        </div>
      </div>
    </div>

    <!-- 遮罩层 -->
    <div class="mask" v-if="isMenuOpen" @click="toggleMenu"></div>

    <!-- 主要内容区域 -->
    <div class="mobile-content">
      <router-view />
    </div>

    <!-- 底部导航 -->
    <div class="mobile-footer">
      <div class="footer-item"
           @click="$router.push('/')"
           :class="{ 'active': $route.path === '/' || $route.path === '/index' }">
        <i class="el-icon-s-home"></i>
        <span>首页</span>
      </div>
      <div class="footer-item"
           @click="$router.push('/product')"
           :class="{ 'active': $route.path === '/product' }">
        <i class="el-icon-goods"></i>
        <span>产品</span>
      </div>
      <div class="footer-item"
           @click="$router.push('/case')"
           :class="{ 'active': $route.path === '/case' }">
        <i class="el-icon-s-data"></i>
        <span>案例</span>
      </div>
      <div class="footer-item"
           @click="$router.push('/contact')"
           :class="{ 'active': $route.path === '/contact' }">
        <i class="el-icon-edit-outline"></i>
        <span>试用</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MobileLayout',
  data() {
    return {
      isMenuOpen: false
    }
  },
  computed: {
    topNav() {
      const navList = this.$store.state.getHomeData.topNav
      const idMap = {
        '/': 0,
        '/product': 11,
        '/case': 2,
        '/industry': 3,
        '/new': 4,
        '/about': 6,
        '/contact': 7
      }
      return navList.map(item => ({
        ...item,
        id: idMap[item.url] || item.id || 0
      }))
    },
    contact() {
      return this.$store.state.getHomeData.contact
    }
  },
  created() {
    // 确保导航数据加载
    if (!this.$store.state.getHomeData.topNav || !this.$store.state.getHomeData.topNav.length) {
      this.$store.dispatch('getHomeData')
    }
  },
  methods: {
    toggleMenu() {
      this.isMenuOpen = !this.isMenuOpen
      if (this.isMenuOpen) {
        document.body.style.overflow = 'hidden'
      } else {
        document.body.style.overflow = 'auto'
      }
    },
    handleMenuClick(item) {
      this.$router.push(item.url)
      this.toggleMenu()
    }
  }
}
</script>

<style lang="scss" scoped>
.mobile-layout {
  min-height: 100vh;
  background: #f5f5f5;
}

.mobile-header {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: 50px;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 15px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
  z-index: 100;

  .logo {
    display: flex;
    align-items: center;

    img {
      height: 30px;
      margin-right: 8px;
    }

    span {
      font-size: 16px;
      font-weight: bold;
      color: #333;
    }
  }

  .menu-icon {
    font-size: 24px;
    color: #333;
  }
}

.mobile-menu {
  position: fixed;
  top: 0;
  right: -80%;
  width: 80%;
  height: 100vh;
  background: #fff;
  z-index: 1000;
  transition: all 0.3s ease;
  box-shadow: -2px 0 8px rgba(0,0,0,0.1);

  &.menu-active {
    right: 0;
  }

  .menu-header {
    height: 50px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 15px;
    border-bottom: 1px solid #eee;

    span {
      font-size: 16px;
      font-weight: bold;
    }

    i {
      font-size: 20px;
      color: #666;
    }
  }

  .menu-list {
    padding: 15px 0;

    .menu-item {
      padding: 15px;
      font-size: 16px;
      color: #333;
      border-bottom: 1px solid #f5f5f5;

      &:active {
        background: #f5f5f5;
      }
    }
  }
}

.mask {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0,0,0,0.5);
  z-index: 999;
}

.mobile-content {
  padding: 60px 0 60px;
  min-height: calc(100vh - 120px);
}

.mobile-footer {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  height: 90px;
  background: #fff;
  display: flex;
  box-shadow: 0 -2px 4px rgba(0,0,0,0.1);

  .footer-item {
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    color: #666;
    font-size: 18px;

    i {
      font-size: 28px;
      margin-bottom: 2px;
    }

    &.active {
      color: #2c9dcf;
    }
  }
}
</style>
